<template>
	<section class="footer-modal">
		<div class="footer-container">
			<app-button
				v-if="!hidden"
				text="Cancelar"
				@click="cancelModal"
				width="109"
				red
			></app-button>
			<app-button 
				:text="successText"
				:disabled="isLoading"
				v-if="!hiddenSaveBtn"
				width="109"
				@click="setInfo"
				gray>
			</app-button>
		</div>
	</section>
</template>

<script>
import appButton from '@/components/shared/app-button';

function cancelModal() {
	this.$emit('cancel-button-clicked');
}

function setInfo() {
	this.$emit('accept-button-clicked');
}

export default {
	name: 'modal-sidebar-button',
	components: {
		appButton,
	},
	methods: {
		cancelModal,
		setInfo,
	},
	props: {
		isLoading: {
			default: false,
			type: Boolean,
		},
		hidden: {
			type: Boolean,
			default: false,
		},
		hiddenSaveBtn: {
			type: Boolean,
			default: false,
		},
		successColor: {
			default: 'success',
			type: String,
		},
		successImg: {
			default: 'icon-apply.svg',
			type: String,
		},
		successText: {
			default: 'Aceptar',
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
.footer-modal {
	border: 1px solid map-get($colors, grey);
	height: 9vh;
	width: 100%;

	.footer-container {
		@include flex-center;
		height: 100%;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/shared/utils/modal-sidebar-button.vue